'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ObjectFieldTemplate = function ObjectFieldTemplate(props) {
  var description = props.description,
      properties = props.properties,
      schema = props.schema;
  // console.log('ObjectFieldTemplate: ', props);

  if (schema.root) {
    return _react2.default.createElement(
      'div',
      { className: _style2.default.form + ' ant-row' },
      description,
      properties.map(function (prop) {
        return prop.content;
      })
    );
  }
  return _react2.default.createElement(
    'div',
    { className: 'ant-row ant-col-md-24' },
    _react2.default.createElement(
      'div',
      { className: 'ant-row' },
      schema.label,
      description
    ),
    _react2.default.createElement(
      'div',
      { className: 'ant-row ' + _style2.default.fieldset },
      properties.map(function (prop) {
        return prop.content;
      })
    )
  );
};

ObjectFieldTemplate.defaultProps = {
  description: '',
  properties: []
};

ObjectFieldTemplate.propTypes = {
  description: _propTypes2.default.string,
  properties: _propTypes2.default.array,
  schema: _propTypes2.default.object.isRequired
};

exports.default = ObjectFieldTemplate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/slide-new-toolkit/dist/Form/FieldTemplates/ObjectFieldTemplate/index.js
// module id = 1030
// module chunks = 0